/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check-mark': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.471 9.529l6.196-6.196.942.943-7.138 7.138L2.667 7.61l.942-.942z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
